module.exports = __webpack_public_path__ + "img/rechargeable.29a2ff33.png";